import { useState } from 'react';
import { useRouter } from 'next/router';
import PositionChallengeList from '@components/position/jd/positionChallenge/positionChallengeList';
import PositionChallengeModal from '@components/position/jd/positionChallenge/positionChallengeModal';
import { useMatchingChallenge } from '@repository/position/usePosition';
import { PositionDetailVO } from '@domain/vo/position/jd/PositionDetailVO';
import classnames from 'classnames/bind';
import styles from './positionChallenge.module.scss';

const cx = classnames.bind(styles);

interface PositionChallengeProps {
  positionDetail: PositionDetailVO;
}

const PositionChallenge = ({ positionDetail }: PositionChallengeProps) => {
  const { query } = useRouter();
  const positionSn = Number(query.sn);
  const [modalVisible, setModalVisible] = useState(false);

  const { data: positionChallengeList, isLoading } = useMatchingChallenge(positionSn);

  const {
    additionalInfo: { challenge },
  } = positionDetail;

  if (!challenge || challenge.challengeStatus !== 'PROGRESS' || !positionChallengeList || isLoading) return null;

  const { positions } = positionChallengeList;

  if (!positions || positions.length === 0) return null;

  return (
    <div className={cx('positionWrap')}>
      <em className={cx('title')}>
        {challenge?.challengeName}
        <span className={cx('text')}>에서 채용중인 다른 포지션을 만나보세요.</span>
      </em>

      <PositionChallengeList positions={positions} setModalVisible={setModalVisible} />

      <PositionChallengeModal
        positionDetail={positionDetail}
        positions={positions}
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
      />
    </div>
  );
};

export default PositionChallenge;
